import { Subject } from 'rxjs';
import { Injectable, ElementRef } from "@angular/core";

@Injectable({ providedIn: "root" })
export class TooltipService {
  private _text: string;
  private _show: boolean;
  private _elementRef: HTMLElement;
  private _appendToBody: boolean;
  tooltipToggle: Subject<boolean> = new Subject<boolean>();

  set text(t: string) {
    this._text = t;
  }

  get text(): string {
    return this._text;
  }

  set show(s: boolean) {
    this._show = s;
  }

  get show() {
    return this._show;
  }

  get elementRef(): HTMLElement {
    return this._elementRef;
  }

  get appendToBody(): boolean {
    return this._appendToBody;
  }

  setTooltipData(t: string, s: boolean, ref: HTMLElement, appendBody: boolean) {
    this._text = t;
    this._elementRef = ref;
    this._appendToBody = appendBody;
    this._show = s;
    this.tooltipToggle.next(s);
  }
}